import React from 'react';
import { round } from 'lodash';
import * as shapes from './shapes';

const Hours = ({ children }) => (
  <React.Fragment>
    {typeof children === 'number' ? round(children, 2) : children}
  </React.Fragment>
);
Hours.propTypes = { children: shapes.childrenOrValue };
Hours.defaultProps = { children: null };

export default Hours;
